/**
 * Generato automaticamente.
 * framework-cmp-domande
 */
import { useMutation } from 'react-query';
import type { MutationFunction, UseMutationOptions } from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  PostFrontPmpfDomandeImportaBody,
  PostFrontPmpfDomandeImportaParams,
  SQLTransferResponse,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Importa una serie di domande da PMPF
 * @summary Importa una serie di domande da PMPF
 */
export const postFrontPmpfDomandeImporta = (
  postFrontPmpfDomandeImportaBody: PostFrontPmpfDomandeImportaBody,
  params?: PostFrontPmpfDomandeImportaParams,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  formData.append('file', postFrontPmpfDomandeImportaBody.file);

  return apiClientRequest<SQLTransferResponse>(
    {
      url: `/framework-cmp-domande/pmpf/domande/importa`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      params,
    },
    options,
  );
};

export const getPostFrontPmpfDomandeImportaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontPmpfDomandeImporta>>,
    TError,
    {
      data: PostFrontPmpfDomandeImportaBody;
      params?: PostFrontPmpfDomandeImportaParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontPmpfDomandeImporta>>,
  TError,
  {
    data: PostFrontPmpfDomandeImportaBody;
    params?: PostFrontPmpfDomandeImportaParams;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontPmpfDomandeImporta>>,
    {
      data: PostFrontPmpfDomandeImportaBody;
      params?: PostFrontPmpfDomandeImportaParams;
    }
  > = props => {
    const { data, params } = props ?? {};

    return postFrontPmpfDomandeImporta(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontPmpfDomandeImportaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontPmpfDomandeImporta>>
>;
export type PostFrontPmpfDomandeImportaMutationBody =
  PostFrontPmpfDomandeImportaBody;
export type PostFrontPmpfDomandeImportaMutationError = ErrorType<unknown>;

/**
 * @summary Importa una serie di domande da PMPF
 */
export const usePostFrontPmpfDomandeImporta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontPmpfDomandeImporta>>,
    TError,
    {
      data: PostFrontPmpfDomandeImportaBody;
      params?: PostFrontPmpfDomandeImportaParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontPmpfDomandeImportaMutationOptions(options);

  return useMutation(mutationOptions);
};
